import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "#fff"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M1.5 5.6a3.3 3.3 0 0 1 3.3-3.1h10.4c1.7 0 3.2 1.4 3.3 3.1L19 14c.1 1.9-1.4 3.5-3.3 3.5h-2c-1.5 0-3-1.2-3.2-2.8l-.4-2a.2.2 0 0 0-.2 0l-.4 2a3.3 3.3 0 0 1-3.3 2.8H4.3C2.4 17.5 1 15.9 1 14zm3.3-1.4c-.8 0-1.6.7-1.6 1.5l-.5 8.4c-.1 1 .7 1.7 1.6 1.7h2c.7 0 1.4-.6 1.6-1.4l.3-2a1.8 1.8 0 0 1 3.6 0l.3 2c.2.8.9 1.4 1.7 1.4h1.9c1 0 1.7-.8 1.6-1.7l-.5-8.4c0-.8-.8-1.5-1.6-1.5z",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", { d: "M1.4 8.3V6.7h17.1l.1 1.6z" }, null, -1)
  ]))]))
}
export default { render: render }